const domain =
  import.meta.env.VITE_API_DOMAIN || 'https://dev-transfer.glonasssoft.ru'

export const getSourceApi = (system?: string | null) => {
  if (system) {
    return `${domain}/sourceservice/${system}/api`
  }
  return `${domain}/sourceservice/api`
}

export const receiverApi = `${domain}/receiverservice/api`
export const credentialsApi = `${domain}/credentialsservice/api`
